module.exports = __webpack_public_path__ + "static/media/reservation.5af4443a.svg";